const DEFAULT_CURRENCY = "USD";

export const formatCurrencyWithCents = (
  value: number | string,
  currency: string = DEFAULT_CURRENCY
): string => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(0);
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};
